import { render, staticRenderFns } from "./BasicInfoUpdate.vue?vue&type=template&id=e1982794"
import script from "./BasicInfoUpdate.vue?vue&type=script&lang=js"
export * from "./BasicInfoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports